export default __webpack_public_path__ + "static/6-c694a830940a28c02d21bd4a1d2b1437.png";